import { PropertiesRegisterPage } from '@/features/properties/pages/properties-register-page';

export const PropertiesRegisterRoute = () => {
  return <PropertiesRegisterPage />;
};
